import React from 'react';
import { useRedirect } from '../../../../hooks/useRedirect';
import { ModalLoading } from '../ModalLoading/ModalLoading';

interface IModalTimerProps {
    children?: React.ReactNode;
    label?: string;
    loaderSize?: number;
    redirectTime: number;
    redirectRoute: string;
    timer: boolean;
}

export const ModalTimer: React.FC<IModalTimerProps> = ({ children, label = 'Provide label', loaderSize = 30, redirectTime, redirectRoute, timer = true }) => {
    const { count } = useRedirect(redirectTime, redirectRoute, timer);

    return <ModalLoading label={label} loaderSize={loaderSize} />;
};
